import ResultPage from '@/components/Result/index'

const ShareDataSuccessPage = () => {
	const breadcrumbItem = [
		{
			label: '',
			link: `/`,
		},
		{
			label: 'Received Data',
			link: `/received-data`
		},
		{
			label: 'Request Data',
			link : `/received-data/request`,
		},
		{
			label: 'Fail',
			link: `/received-data/request/fail`
		}
	]

	return ResultPage({
		layoutHeaderTxt: "somethingWrong",
		layoutSubHeaderTxt: "somethingWrongRequestingMessage",
		layoutContentImgPath: "/img/fail.png",
		backBtnTxt: "tryAgain",
		defaultTitle: "requestData",
		nextLocation: '/received-data/request',
		breadcrumbs: breadcrumbItem,
	});
}
export default ShareDataSuccessPage
